import { render, staticRenderFns } from "./TierBeneficiaryForm.vue?vue&type=template&id=29ac86d1&scoped=true&"
import script from "./TierBeneficiaryForm.vue?vue&type=script&lang=js&"
export * from "./TierBeneficiaryForm.vue?vue&type=script&lang=js&"
import style0 from "./TierBeneficiaryForm.vue?vue&type=style&index=0&id=29ac86d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac86d1",
  null
  
)

export default component.exports